import { render, staticRenderFns } from "./ResetPasswordButton.vue?vue&type=template&id=281aabb7&"
import script from "./ResetPasswordButton.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports